import { render, staticRenderFns } from "./TraceDetail.vue?vue&type=template&id=0001a2ca&scoped=true&"
import script from "./TraceDetail.vue?vue&type=script&lang=js&"
export * from "./TraceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0001a2ca",
  null
  
)

export default component.exports